module.exports = __webpack_public_path__ + "static/media/typeface-logo-stg1.409069a7.svg";